import { CheckOutlined, CloseOutlined } from '@mui/icons-material';
import { Chip } from '@mui/material';
import React from 'react';
export const RpmConsentStatus = ({ consentStatus }) => {
    // start with "No Consent" defaults
    let backgroundColor = '#FFFFFF';
    let chipIcon = null;
    let textColor = '#00000099';
    let borderColor = '#00000099';
    if (consentStatus === 'Opt Out') {
        backgroundColor = '#FFFFFF';
        chipIcon = React.createElement(CloseOutlined, { style: { color: '#D32F2F', fontSize: '16px' } });
        textColor = '#D32F2F';
        borderColor = '#D32F2F';
    }
    if (consentStatus === 'Consented') {
        backgroundColor = '#FFFFFF';
        chipIcon = React.createElement(CheckOutlined, { style: { color: '#2C78EB', fontSize: '16px' } });
        textColor = '#2C78EB';
        borderColor = '#2C78EB';
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Chip, { label: 'RPM', variant: 'outlined', size: 'small', ...(chipIcon ? { icon: chipIcon } : {}), style: {
                color: textColor,
                borderRadius: '6px',
                borderColor: borderColor,
                backgroundColor: backgroundColor,
                width: '64px',
                fontWeight: '700',
                fontSize: 'x-small'
            } })));
};
